import { render } from "./AssistedContact.vue?vue&type=template&id=7ac3e69e"
import script from "./AssistedContact.vue?vue&type=script&lang=js"
export * from "./AssistedContact.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__